import MChip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Chip = styled(MChip)({
  borderColor: `${colors.rose200} !important`,
  backgroundColor: `${colors.rose100} !important`,

  "& span": {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    color: colors.rose800,

    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
});
